import * as yup from "yup"
import validationMessages from "@utils/validation/messages";

const fileRequired = (fileSize: number, supportedFormats: string[]) =>
    yup.mixed()
        .test(
            "fileUploaded",
            validationMessages.required,
            value => value && value.length
        )
        .test(
            "fileFormat",
            validationMessages.fileTypeInvalid,
            checkIfFilesAreTooBig
        )
        .test(
            "fileSize",
            validationMessages.fileToolarge,
            checkIfFilesAreCorrectType
        )

export default fileRequired

const checkIfFilesAreTooBig = (files: [File]): boolean => {

        if (!files.length) return true // attachment is optional

        let valid = true
        if (files) {
                Array.from(files).map(file => {
                        const size = file.size / 1024 / 1024
                        if (size > 10) {
                                valid = false
                        }
                })
        }
        return valid
}

const checkIfFilesAreCorrectType = (files: [File]): boolean => {
        if (!files.length) return true // attachment is optional

        let valid = true
        if (files) {
                Array.from(files).map(file => {
                        if (!['application/pdf'].includes(file.type)) {
                                valid = false
                        }
                })
        }
        return valid
}